<template>
	<v-layout fill-height justify-center align-center column>
		<v-progress-circular indeterminate :size="80" />
	</v-layout>
</template>


<script>
export default {
	name: 'splash-screen',
}
</script>
